import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums';
import { useRouter } from 'vue-router';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { useRedeSubredeStore } from '@/stores/redeSubredeStore';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import messages from '@/utils/messages';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnReviewFocusedInstitutional',
  props: {
    accordionRef: {}
  },
  setup(__props: any) {

const router = useRouter();
const institutionalStore = useInstitutionalStore();
const redeSubredeStore = useRedeSubredeStore();
const $q = useQuasar();

const props = __props;

// const onReviewInstitutionalClick = () => {
//   const imagens = props.accordionRef?.getImagensSemUpload?.() || []

//   const exibeTelaAbertura = props.accordionRef?.getExibeTelaAbertura?.() ?? false
//   const alterarTelaAbertura = props.accordionRef?.getAlterarTelaAbertura?.() ?? 'nao'
//   const telas = props.accordionRef?.getTelasSeleccionadas?.() || []
//   const corTexto = props.accordionRef?.getCorTexto?.() ?? null

//   if (!institutionalStore.validateFocusedInstitutionalFields(imagens, alterarTelaAbertura)) return

//   const data = institutionalStore.institutionalDetail || institutionalStore.institutionalDraft

//   if (data) {
//     data.exibeTelaAbertura = exibeTelaAbertura
//     ;(data as any).alterarTelaAbertura = alterarTelaAbertura
//     ;(data as any).telasCadastradas = telas
//     data.corTexto = corTexto ?? undefined
//   }

//   institutionalStore.setReviewData({
//     ...data,
//     imagens,
//     telasCadastradas: telas,
//     corTexto,
//     exibeTelaAbertura,
//     alterarTelaAbertura
//   })

//   institutionalStore.setImagensDraft(imagens)
//   institutionalStore.setTelasDraft(telas)
//   institutionalStore.setExibeTelaAbertura(exibeTelaAbertura)

//   router.push({
//     name: EnumRouteNames.INSTITUTIONAL_REVIEW,
//     ...(data?.id ? { params: { id: data.id } } : {})
//   })
// }

const onReviewInstitutionalClick = () => {
  const imagens = props.accordionRef?.getImagensSemUpload?.() || []

  const exibeTelaAbertura = props.accordionRef?.getExibeTelaAbertura?.() ?? false
  const alterarTelaAbertura = props.accordionRef?.getAlterarTelaAbertura?.() ?? 'nao'

  if (!institutionalStore.validateFocusedInstitutionalFields(imagens, alterarTelaAbertura)) return

  const telas = props.accordionRef?.getTelasSeleccionadas?.() || []
  const corTexto = props.accordionRef?.getCorTexto?.() ?? null

  const data = institutionalStore.institutionalDetail || institutionalStore.institutionalDraft

  if (data) {
    data.exibeTelaAbertura = exibeTelaAbertura
    ;(data as any).alterarTelaAbertura = alterarTelaAbertura
    data.corTexto = corTexto ?? undefined
  }

  institutionalStore.setReviewData({
    ...data,
    imagens,
    telasCadastradas: telas,
    corTexto,
    exibeTelaAbertura,
    alterarTelaAbertura
  })

  institutionalStore.setImagensDraft(imagens)
  institutionalStore.setTelasDraft(telas)
  institutionalStore.setExibeTelaAbertura(exibeTelaAbertura)

  if ((data as any)?.id) {
    institutionalStore.setVeioDaReview(true)
    router.push({
      name: EnumRouteNames.INSTITUTIONAL_REVIEW,
      params: { id: (data as any).id }
    })
  } else {
    router.push({ name: EnumRouteNames.INSTITUTIONAL_REVIEW })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_openBlock(), _createBlock(_component_c_q_btn, {
    id: "btn-review-institutional",
    propBtnLabel: "Revisar Cadastro",
    propBtnFunction: onReviewInstitutionalClick,
    propBtnTransparent: false,
    propBtnSize: _unref(EnumButtonSizes).LARGE_1
  }, null, 8, ["propBtnSize"]))
}
}

})